/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import ContractTableApp from "../../Functionality/ContractTableApp";
import CustomTable from "../../../../../components/table/CustomTable";
import React from "react";
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import {permissionObj} from "../../../../../Helpers/permission";
import CustomButtonLink from "../../../../../components/buttons/CustomButtonLink";
import routes from "../../../../../Routes/routes";


const ContractTable = (props) => {
    const {
        contractorId,
        selectedList,
        setSelectedList,
        isAllChecked,
        searchElement,
        setSearchElement,
        supplierId,
        setSearch,
        setSimpleSearch,
        setBodyForExport,
        modified,
        setModified,
        setIsAllChecked,
        setDeleteContractShow
    } = props;
    const {
        t,
        DEV,
        navigate,
        permission,
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        getActionsButtons,
        handleCheckboxChange,
        handleDeleteAll,
        setResults,
        option,
        rowsPerPage,
        deletePermission
    } = ContractTableApp({
        searchElement,
        contractorId,
        selectedList,
        setSelectedList,
        modified,
        setModified,
        setBodyForExport,
        setIsAllChecked,
        setDeleteContractShow
    });

    return (
        <>
            <div className={"d-flex"}>
                <div className={"ml-2 w-100"}>
                    <SearchSimple
                        id={searchId}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        rowsPerPage={rowsPerPage}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        contractorId={contractorId}
                        supplierId={supplierId}
                    />
                </div>
            </div>

            <CustomTable tableId={tableId}
                         searchId={searchId}
                         checkbox={contractorId === null && deletePermission}
                         checkboxTitle={"de_/_select_all"}
                         isAllChecked={isAllChecked}
                         onChangeCheckbox={handleDeleteAll}
                         thead={thead}
                         tbody={tbody}
                         columnActions={true}
                         getActionsButtons={getActionsButtons}
                         handleCheckboxChange={handleCheckboxChange}
                         selectedList={selectedList}
                         childrenNotInformation={tbody?.data?.length === 0 ? <>
                                 <div className={"warning-text"}>
                                     <p>{t("you_haven_not_created_any_contract_yet")}</p>
                                 </div>
                                 { (DEV || permission?.includes(permissionObj?.WEB_CONTRACTOR_CONTRACT_CREATE)) &&
                                 <CustomButtonLink splitName={false} id={'btn_ct_create'} card={true}
                                                   onClick={() => navigate(routes.employee.createContract)}
                                                   name={'create_new_contract'}/>
                                 } </>
                             : undefined
                         }
            />
            {pagination()}
        </>
    );
};
export default ContractTable;
